import { Component, inject, signal } from '@angular/core';
import { SeoService } from '../../shared/seo.service';
import { SEO_PAGES_CONFIG } from '../../shared/header/header.lists';
import { Pages } from '../../shared/types/common.enums';

@Component({
  selector: 'app-corn-maze',
  imports: [],
  templateUrl: './corn-maze.component.html',
  styleUrl: './corn-maze.component.scss'
})
export class CornMazeComponent {

  #seoService = inject(SeoService);

  constructor() {
    this.#seoService.setUpSEOTags(SEO_PAGES_CONFIG[Pages.cornMaze]);
  }

  gallery = signal(
    [
      {
        "name": "activity-1.webp",
        "alt": "Young children sitting on the floor in a circle, participating in a group activity with educational cards."
      },
      {
        "name": "activity-2.webp",
        "alt": "Group of children playing a collaborative game with colorful balls inside a classroom."
      },
      {
        "name": "activity-3.webp",
        "alt": "Children lining up and forming words with large colorful letters on the floor, guided by a teacher."
      },
      {
        "name": "activity-4.webp",
        "alt": "Outdoor activity where several children are tossing balls into a basket, practicing motor coordination."
      },
      {
        "name": "activity-5.webp",
        "alt": "Children playing a sorting game with illustrated cards, seated around a table."
      },
      {
        "name": "activity-6.webp",
        "alt": "Children lining up to throw rings onto a bottle as part of a target game."
      },
      {
        "name": "activity-7.webp",
        "alt": "Children in a classroom playing a matching game with images and words on the floor."
      },
      {
        "name": "activity-8.webp",
        "alt": "Physical activity where children are jumping through colorful hoops placed on the ground."
      },
      {
        "name": "activity-9.webp",
        "alt": "Children forming words with moveable letters during a group activity on a carpet."
      },
      {
        "name": "activity-10.webp",
        "alt": "Teacher guiding a group of children through a reading activity using illustrated cards."
      },
      {
        "name": "2024.webp",
        "alt": "Aerial view of a corn maze featuring gymnast Brody Malone with gymnastic equipment, American flag elements, and the year '2024'.",
        fill: true
      },
      {
        "name": "2023.webp",
        "alt": "Aerial view of a corn maze honoring a baseball player in mid-pitching motion, with the word 'REDS' and other decorative text.",
        fill: true
      },
      {
        "name": "2022.webp",
        "alt": "Aerial view of a corn maze celebrating 150 years of Rockmart, with a large clock tower and the year '1872' carved into the field.",
        fill: true
      },
      {
        "name": "2021.webp",
        "alt": "Aerial view of a corn maze featuring a football helmet, arch structure, and the word 'Bulldogs' with the year '2021' carved into the field.",
        fill: true
      },
      {
        "name": "2019.webp",
        "alt": "Aerial view of a corn maze with a barn, tree, and the phrases 'Calhoun Farms' and '1 Farm 1 Family' carved into the field.",
        fill: true
      },
      {
        "name": "2018.webp",
        "alt": "Aerial view of a corn maze designed with interlocking rings and labeled 'Granny's Quilt 2018', resembling a traditional quilt pattern.",
        fill: true
      },
      {
        "name": "2017.webp",
        "alt": "Aerial view of a corn maze depicting a musical theme with the word 'Rockmart' and 'Yellow Jackets' along with a hornet mascot and music notes.",
        fill: true
      },
      {
        "name": "2015.webp",
        "alt": "Aerial view of a corn maze featuring Sesame Street characters carved into the field.",
        fill: true
      }
    ]

  );
}
